import { TITLE_ATTRIBUTE } from '@core/constants/ATTRIBUTES';
import { IMAGE_NOT_FOUND } from '@core/constants/CONSTANTS';

/**
 * @type {string}
 * @description - The results grid layout web component.
 */
export const RESULTS_GRID_LAYOUT_WEB_COMPONENT = 'results-grid-layout';

/**
 * @type {{
 *  SEARCH_IMGS_RESULTS: string;
 *  SEARCH_REPORTS_RESULTS: string;
 *  TITLE: string;
 * }}
 * @description - The results grid layout attributes.
 */
export const RESULTS_GRID_LAYOUT_ATTRIBUTES = {
    SEARCH_IMGS_RESULTS: 'search-imgs-results',
    SEARCH_REPORTS_RESULTS: 'search-reports-results',
    TITLE: TITLE_ATTRIBUTE,
};

/**
 * @type {string}
 * @description - The custom results grid loading spinner web component.
 */
export const CUSTOM_RESULTS_GRID_LOADING_SPINNER_WEB_COMPONENT =
    '[data-results-grid-spinner]';

/**
 * Default item.
 * @type {{
 *   img_with: string,
 *   img_height: string,
 *   img_src: string,
 * }}
 */
export const DEFAULT_ITEM = {
    img_with: 'auto',
    img_height: '',
    img_src: IMAGE_NOT_FOUND,
};
